import { render, staticRenderFns } from "./workOrderDetail.vue?vue&type=template&id=65cb7c88&scoped=true"
import script from "./workOrderDetail.vue?vue&type=script&lang=js"
export * from "./workOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./workOrderDetail.vue?vue&type=style&index=0&id=65cb7c88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb7c88",
  null
  
)

export default component.exports